import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="export-modal"
export default class extends Controller {
  static targets = ['dateInput', 'submitBtn', 'modal'];

  connect() {
    this.toggleSubmitButton();
  }

  dateChanged() {
    this.toggleSubmitButton();
  }

  performExport() {
    const dateValue = this.dateInputTarget.value;
    
    if (!dateValue) {
      alert('Bitte wählen Sie ein Datum aus.');
      return;
    }
    
    // Use window.location.href to preserve session cookies
    window.location.href = `/admin/users/export?confirmed_after=${encodeURIComponent(dateValue)}`;
    
    // Close modal after a brief delay
    setTimeout(() => this.closeModal(), 1000);
  }

  closeModal() {
    this.modalTarget.close();
  }

  toggleSubmitButton() {
    this.submitBtnTarget.disabled = !this.dateInputTarget.value;
  }
}